import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedListings from './components/FeaturedListings';
import WhyZoy from './components/WhyZoy';
import Footer from './components/Footer';
import HomeScreen from './components/HomeScreen';
import PropertyDetails from './components/PropertyDetails';
import DeleteUser from './components/DeleteUser';
import PrivacyPolicy from './components/PrivacyPolicy';
import { ToastContainer } from "react-toastify";
import Properties from './components/Properties';
// A Home component that includes all homepage-specific content
function Home() {
  return (
    <>
    <HomeScreen/>
  <ToastContainer/>
    </>
  );
}
 
function App() {
  return (
    <Router>
      {/* <Header /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/propertyDetails" element={<PropertyDetails />} />
        <Route path="/deleteUser" element={<DeleteUser />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}
 
export default App;
 
 